export default {
  about_badge: '// За компанията',
  about_title1: 'RHEINMETALL AG —',
  about_title2: 'ЛИДЕР НА ЕВРОПЕЙСКАТА',
  about_title3: 'ОТБРАНА',
  about_desc1: 'Основана през 1889 г., Rheinmetall AG е най-големият немски отбранителен концерн и един от водещите световни производители на военна техника и боеприпаси. Централата се намира в Дюселдорф, Германия.',
  about_desc2: 'В условията на рязък ръст на отбранителните бюджети на страните от НАТО и Европа, Rheinmetall отчита рекордни финансови резултати. Портфолиото от поръчки надхвърли <strong>€50 милиарда</strong> — гарантирано натоварване на производството до 2030 г. и стабилен доход за инвеститорите.',
  about_tags: 'Бронирана техника,Артилерия,Боеприпаси,Електроника,Киберсигурност',
  about_img_caption: 'Портфолио от поръчки до 2030 г.',
  about_stat1: 'Основана',
  about_stat2: 'Приходи 2024',
  about_stat3: 'Служители',
  about_stat4: 'Страни-партньори',
  weapons_badge: '// Произвеждано въоръжение',
  weapons_title1: 'ВЪОРЪЖЕНИЕ',
  weapons_title2: 'ОТ НОВО ПОКОЛЕНИЕ',
  weapons_subtitle: 'Пълен производствен цикъл от боеприпаси до бронирана техника. Доставки в 50+ страни. Всеки договор е вашата печалба.',
  weapons_specs_label: 'Характеристики',
  weapons_hide: 'Скрий',
  weapons_show: 'Характеристики',
  w1_title: 'Основни бойни танкове', w1_desc: 'Най-добрият в света основен боен танк. Leopard 2A8 е оборудван с активна защита Trophy, най-новата система за управление на огъня и 120-мм гладкоцевно оръдие Rh-120.', w1_tag: 'Бронирана техника', w1_rev: '€8.2 млрд поръчки',
  w2_title: 'Самоходна гаубица', w2_desc: 'Най-точната самоходна артилерийска установка в света. Обсег до 67 км с управляеми снаряди. Използва се от армиите на Германия, Нидерландия, Гърция, Италия и Украйна.', w2_tag: 'Артилерия', w2_rev: '€3.5 млрд поръчки',
  w3_title: 'Бойна машина на пехотата', w3_desc: 'Най-новата БМП от ново поколение с модулна архитектура. Въоръжена с 35-мм автоматично оръдие Wotan и противотанкови ракети Spike LR2.', w3_tag: 'БМП', w3_rev: '€5.1 млрд поръчки',
  w4_title: 'Зенитно-ракетен комплекс', w4_desc: 'Революционна система за противовъздушна отбрана срещу дронове, хеликоптери и нисколетящи самолети. 30-мм оръдие с темп на стрелба 1200 изстр/мин.', w4_tag: 'ПВО', w4_rev: '€2.8 млрд поръчки',
  w5_title: 'Боеприпаси 155-мм', w5_desc: 'Rheinmetall — най-големият производител на артилерийски боеприпаси в Европа. Производството на 155-мм снаряди е увеличено 8 пъти.', w5_tag: 'Боеприпаси', w5_rev: '€4.7 млрд поръчки',
  w6_title: 'Зенитен танк Gepard', w6_desc: 'Легендарна зенитна самоходна установка с две 35-мм оръдия. Доказа ефективността си срещу дронове и крилати ракети в реални бойни условия.', w6_tag: 'ЗСУ', w6_rev: '€1.9 млрд поръчки',
  conflicts_badge: '// Участие в конфликти',
  conflicts_title1: 'КРИТИЧНА РОЛЯ В',
  conflicts_title2: 'ГЛОБАЛНАТА СИГУРНОСТ',
  conflicts_subtitle: 'Rheinmetall доставя техника в горещи точки и зони на конфликти. Всеки изстрел е вашият доход. Войната е бизнес и ви предлагаме да станете част от него.',
  conflicts_deliveries: 'Доставки',
  conflicts_hide: 'Скрий',
  conflicts_more: 'Подробности',
  conflicts_why_label: 'Защо е изгодно',
  conflicts_why_title: 'ВОЙНАТА Е РЪСТ НА АКЦИИТЕ',
  conflicts_why_desc: 'Отбранителните бюджети на страните от НАТО са нараснали с <strong>+40% за 2 години</strong>. Германия увеличи военните разходи до €100 млрд. Полша харчи 4% от БВП за отбрана.',
  stat_stocks: 'Ръст на акциите за 3 години',
  stat_backlog: 'Портфолио от поръчки',
  stat_ammo: 'Ръст на производството на снаряди',
  c1_region: 'Украйна', c1_status: 'Активно', c1_desc: 'Най-големият купувач на техника на Rheinmetall. Доставени са стотици единици Leopard 2, Marder, Gepard. Открит е съвместен завод за производство на бронирана техника в Украйна.',
  c2_region: 'Полша', c2_status: 'Договорът е подписан', c2_desc: 'Полша реализира най-голямата програма за превъоръжаване в историята на страната. Поръчани са 800 танка K2 с кули Rheinmetall, 500 БМП Lynx KF41.',
  c3_region: 'Германия', c3_status: 'Дългосрочен', c3_desc: 'Бундесверът провежда мащабна модернизация. Поръчани са 18 PzH 2000, 123 Leopard 2A8, 143 Lynx KF41. Отбранителният бюджет на Германия нарасна до €100 млрд.',
  c4_region: 'Унгария', c4_status: 'Производство', c4_desc: 'Унгария строи завод на Rheinmetall на своя територия. Поръчани са 218 Lynx KF41 — най-големият договор за БМП в историята на Европа.',
  c5_region: 'Австралия', c5_status: 'Нов договор', c5_desc: 'Австралия избра Lynx KF41 за замяна на остарелите M113. Договор за 450 машини с производство в Австралия.',
  c6_region: 'Румъния', c6_status: 'Преговори', c6_desc: 'Румъния планира закупуването на 300 Lynx KF41 и 54 PzH 2000. Страната граничи с Украйна и активно изгражда военен потенциал с подкрепата на НАТО.',
  calc_badge: '// Калкулатор за печалба',
  calc_title1: 'ИЗЧИСЛЕТЕ',
  calc_title2: 'ВАШАТА ПЕЧАЛБА',
  calc_subtitle: 'Прозрачна система на доходност без скрити комисионни. Всички сделки за 3 дни.',
  calc_plan1: 'Старт',
  calc_plan2: 'Оптимум',
  calc_plan3: 'Премиум',
  calc_popular: 'Популярен',
  calc_per_year: '%',
  calc_custom_label: 'Собствена сума (€)',
  calc_custom_placeholder: 'Мин. €',
  calc_period_label: 'Срок на сделка: 3 дни',
  calc_period_months: '',
  calc_profit_label: 'Вашата печалба за 3 дни',
  calc_profit_months: '',
  calc_total_label: 'Крайна сума: ',
  calc_invested: 'Инвестирано',
  calc_rate: 'Лихва',
  calc_per_yr: '%',
  calc_cta: 'Открий инвестиционна сметка',
  calc_feat1_title: 'Застраховане на депозити', calc_feat1_desc: 'Средствата ви са защитени от европейската система за застраховане на депозити',
  calc_feat2_title: 'Тримесечни плащания', calc_feat2_desc: 'Получавайте печалба на всеки 3 месеца по вашата сметка',
  calc_feat3_title: 'Правна защита', calc_feat3_desc: 'Договор по германско право, нотариално заверен',
  contact_badge: '// Контакти',
  contact_title1: 'ЗАПОЧНЕТЕ',
  contact_title2: 'ДА ИНВЕСТИРАТЕ ДНЕС',
  contact_subtitle: 'Оставете заявка и нашият мениджър ще се свърже с вас в рамките на 24 часа за откриване на инвестиционна сметка.',
  contact_why_title: 'Защо ни избират',
  contact_r1_title: 'Лицензиран брокер', contact_r1_desc: 'Дейността се регулира от BaFin (Германия) и FCA (Великобритания)',
  contact_r2_title: 'Сигурност на средствата', contact_r2_desc: 'Средствата се съхраняват в сегрегирани сметки в Deutsche Bank',
  contact_r3_title: 'Личен мениджър', contact_r3_desc: 'Индивидуално придружаване през целия срок на инвестицията',
  contact_r4_title: 'Бърз старт', contact_r4_desc: 'Сметката се открива за 24 часа, първите плащания след 3 месеца',
  contact_address_label: 'Адрес',
  contact_form_title: 'Заявка за инвестиция',
  contact_name_label: 'Вашето име *',
  contact_name_placeholder: 'Иван Иванов',
  contact_email_label: 'Email *',
  contact_phone_label: 'Телефон',
  contact_phone_placeholder: '+359 99 000 0000',
  contact_amount_label: 'Сума на инвестицията',
  contact_amount_placeholder: 'Изберете план',
  contact_amount_opt1: '€3,000 — 24%',
  contact_amount_opt2: '€5,000 — 29%',
  contact_amount_opt3: '€10,000 — 37%',
  contact_amount_opt4: 'Индивидуална сума',
  contact_msg_label: 'Съобщение',
  contact_msg_placeholder: 'Вашите въпроси или пожелания...',
  contact_submit: 'Изпрати заявка',
  contact_sending: 'Изпращане...',
  contact_success: 'Заявката е изпратена! Ще се свържем с вас в рамките на 24 часа.',
  contact_error: 'Грешка при изпращане. Опитайте отново или се свържете с нас директно.',
  contact_privacy: 'С натискането на бутона се съгласявате с политиката за поверителност',
  footer_desc: 'Инвестиционен портал на Rheinmetall AG. Инвестирайте в лидера на европейската отбранителна промишленост.',
  footer_company: 'Компания',
  footer_investors: 'За инвеститори',
  footer_products: 'Продукти',
  footer_about: 'За нас',
  footer_history: 'История',
  footer_production: 'Производство',
  footer_news: 'Новини',
  footer_plans: 'Тарифи',
  footer_calculator: 'Калкулатор',
  footer_docs: 'Документи',
  footer_faq: 'FAQ',
  footer_armor: 'Бронирана техника',
  footer_artillery: 'Артилерия',
  footer_ammo: 'Боеприпаси',
  footer_air: 'ПВО',
  footer_rights: '© 2025 Rheinmetall Investment Portal. Всички права запазени.',
  footer_privacy: 'Политика за поверителност',
  footer_terms: 'Условия за ползване',
  footer_disclaimer: 'Инвестирането е свързано с рискове. Миналите резултати не гарантират бъдещи доходи. Този сайт е с информационен характер и не представлява публична оферта.',
  toast_earned: 'спечели по договор',
  toast_period: 'за 3 дни',

  // Navigation
  nav: {
    about: 'За компанията',
    weapons: 'Въоръжение',
    conflicts: 'Конфликти',
    calculator: 'Калкулатор',
    contact: 'Контакти',
  },

  // Hero Section
  hero: {
    badge: 'Отворено за инвеститори',
    title1: 'ИНВЕСТИЦИИ',
    title2: 'В БЪДЕЩЕТО',
    title3: 'НА ОТБРАНАТА',
    description: 'Rheinmetall AG — най-големият отбранителен концерн в Европа. Инвестирайте от €3 000 и печелете до {{return}} за 3 дни.',
    stat1: 'Печалба до 37% за 3 дни',
    stat2: 'Договори за €50+ млрд до 2030 г.',
    stat3: 'Ръст на акциите +280% за 3 години',
    cta1: 'Изчисли печалбата',
    cta2: 'Научи повече',
    scroll: 'Превърти надолу',
    turretLabel: 'Leopard 2A7+',
    turretHint: 'Кула · кликни за изстрел',
  },

  // About Section
  about: {
    label: 'За компанията',
    title: 'RHEINMETALL AG',
    subtitle: 'Лидер в отбраната на Европа',
    description: 'Немски индустриален конгломерат, световен лидер в производството на бронирана техника и артилерийски системи. От началото на войната в Украйна компанията увеличи производството си с 400%.',
    stats: {
      founded: 'Основана',
      employees: 'Служители',
      revenue: 'Приходи',
      contracts: 'Поръчки',
    },
  },

  // Weapons Section
  weapons: {
    label: 'Военна техника',
    title: 'БОЙНИ СИСТЕМИ',
    subtitle: 'Съвременна бронирана техника и артилерия, съставляващи основата на силите на НАТО',
    items: {
      leopard: {
        name: 'Leopard 2A7+',
        desc: 'Основен боен танк — флагман на европейските бронирани сили',
      },
      lynx: {
        name: 'Lynx KF41',
        desc: 'Бойна машина на пехотата от ново поколение',
      },
      puma: {
        name: 'PUMA',
        desc: 'Тежка бойна машина на пехотата',
      },
      panzerhaubitze: {
        name: 'Panzerhaubitze 2000',
        desc: 'Самоходна гаубица с обсег 40 км',
      },
      fuchs: {
        name: 'Fuchs',
        desc: 'Бронетранспортьор',
      },
      boxer: {
        name: 'Boxer',
        desc: 'Модулна бойна машина',
      },
    },
  },

  // Conflicts Section
  conflicts: {
    label: 'Геополитика',
    title: 'ЗОНИ НА КОНФЛИКТИ',
    subtitle: 'Текущи военни конфликти, стимулиращи растежа на отбранителната промишленост',
    ukraine: {
      title: 'Войната в Украйна',
      description: 'От 2022 г. Rheinmetall достави над 200 танка Leopard и разгърна местно производство. Договори за €8,5 млрд.',
    },
    middleEast: {
      title: 'Близкият изток',
      description: 'Доставки на системи за ПВО и бронирана техника в Катар, ОАЕ и Саудитска Арабия. Договори за €12 млрд.',
    },
    baltic: {
      title: 'Прибалтика',
      description: 'Програма за засилване на НАТО. Нови производства в Литва и Румъния. Инвестиции €2,5 млрд.',
    },
  },

  // Calculator Section
  calculator: {
    label: 'Калкулатор за инвестиции',
    title: 'ИЗЧИСЛЕТЕ ВАШАТА ПЕЧАЛБА',
    subtitle: 'Изчислете потенциалната печалба от инвестиции в акции на Rheinmetall AG',
    amount: 'Сума на инвестицията',
    period: 'Период на инвестиране',
    years: '{{years}} години',
    result: 'Прогнозирана печалба',
    total: 'Крайна сума',
    profit: 'Нетна печалба',
    cta: 'Започни да инвестираш',
  },

  // Contact Section
  contact: {
    label: 'Свържете се с нас',
    title: 'СВЪРЖЕТЕ СЕ С НАС',
    subtitle: 'Нашите инвестиционни консултанти са готови да отговорят на вашите въпроси',
    form: {
      name: 'Вашето име',
      email: 'Email',
      phone: 'Телефон',
      amount: 'Сума на инвестицията',
      message: 'Съобщение',
      submit: 'Изпрати заявка',
      success: 'Благодарим ви! Ще се свържем с вас скоро.',
    },
  },

  // Testimonials
  testimonials: {
    badge: '// Отзиви на инвеститори',
    title1: 'КАКВО КАЗВАТ',
    title2: 'НАШИТЕ ИНВЕСТИТОРИ',
    subtitle: 'Реални резултати от реални инвеститори в цяла Европа. Без лица — само числа.',
    from: 'от',
    stat1: 'Активни инвеститори',
    stat2: 'Общо изплатено',
    stat3: 'Макс. доходност',
    stat4: 'Страни',
    t1: {
      name: 'М. Краузе',
      role: 'Частен инвеститор · Франкфурт',
      text: 'Отначало бях скептичен — инвестициите в отбрана ми изглеждаха твърде нишови. Но след първата сделка, затворена за 3 дни с 37% доходност, удвоих позицията си. Rheinmetall не е просто компания — това е машина за печатане на пари по военно време.',
    },
    t2: {
      name: 'И. Димитров',
      role: 'Предприемач · София',
      text: 'Пробвах много платформи — крипто, форекс, недвижими имоти. Нищо не се сравнява със стабилността тук. Три сделки, три победи. Мениджърът обясни всичко ясно, договорът е по германско право. Спя спокойно.',
    },
    t3: {
      name: 'П. Вишневски',
      role: 'Инженер · Варшава',
      text: 'Полша се превъоръжава с рекордни темпове — реших да спечеля от това. Инвестирах €12 000, получих €16 440 за 3 дни. Сега разказвам на всички колеги. Това е най-логичната инвестиция на нашето време.',
    },
    t4: {
      name: 'Л. Русо',
      role: 'Собственик на бизнес · Милано',
      text: 'В Италия казваме: инвестирай там, където текат парите. А парите сега текат в отбраната. Вложих €20 000 и получих €27 400 обратно. Процесът беше плавен, прозрачен, професионален. Горещо препоръчвам.',
    },
    t5: {
      name: 'Е. Хансен',
      role: 'Финансов анализатор · Осло',
      text: 'Като анализатор следя ежедневно акциите на отбранителни компании. Фундаменталните показатели на Rheinmetall са изключителни — портфолио €50 млрд, подкрепа от НАТО, рекордни маржове. Този портал дава на дребните инвеститори достъп до институционална доходност.',
    },
  },

  // Footer
  footer: {
    rights: '© {{year}} Rheinmetall AG. Всички права запазени.',
    disclaimer: 'Инвестициите в ценни книжа са свързани с рискове. Миналата доходност не гарантира бъдещи резултати.',
  },
};